import { Injectable } from '@angular/core';

import { ConfigParserService } from '../services/config-parser.service';

export interface CreateConfig {
    thirdPartyCreateAppIds: Array<string>;
    createSwayEndpointConsumer: string;
}

@Injectable({
    providedIn: 'root'
})
export class CreateConfigService {
    public readonly config: CreateConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<CreateConfig>('createConfig') || {
            thirdPartyCreateAppIds: [],
            createSwayEndpointConsumer: ''
        };
    }
}
